import IHost from '@/types/IHost';
import { Flex, ListItem, Text } from '@chakra-ui/layout';
import { Avatar, IconButton } from '@chakra-ui/react';
import { Fade } from '@chakra-ui/transition';
import { useTranslation } from 'react-i18next';
import { VscClose } from 'react-icons/vsc';

interface IHostProps extends IHost {
	onRemove: (email: string) => void;
}

export default function Host(props: IHostProps) {
	const { t } = useTranslation();
	return (
		<Fade in={true}>
			<ListItem alignItems="center" display="flex" mt="4">
				<Avatar size="sm" name={props.email} src={props.avatar} />
				<Flex ml="3" flexDir="column">
					<Text>{props.email}</Text>
					<Text color="gray.500" fontSize="sm">
						{props.role === 'OWNER' ? t('Owner') : t('Collaborator')}
					</Text>
				</Flex>
				{props.role !== 'OWNER' ? (
					<IconButton
						onClick={() => props.onRemove(props.email)}
						variant="ghost"
						ml="auto"
						aria-label={t('Remove {{email}}', { email: props.email })}
						icon={<VscClose />}
					/>
				) : null}
			</ListItem>
		</Fade>
	);
}
